import { useEffect, useState } from "react"
import { Box, Breadcrumbs } from "@mui/material"
import { PADDING_BASE } from "../../assets/Styles"
import { Typography } from "@mui/material"
import Link from '@mui/material/Link'
import ElementsListingActions from "../ElementActions/ElementsListingActions"
import { DataElement } from "../../models/element.model"
import { filterElements } from "../../services/element.service"
import Copyright from "../common/Copyright"
import PageContainer from "../common/PageContainer"
import { useNavigate } from "react-router-dom"
import { useProject } from "../../context/ProjectContext"
import DataTable from "../common/DataTable2"
import { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow } from "./scheme"
import { useNotification } from "../../context/NotificationContext"



export default function ElementsListing(props: any) {
  const setBlockScreen = props.setBlockScreen
  const { selectedProject } = useProject()

  const navigate = useNavigate()
  const { showNotification } = useNotification();

  const [elementsList, setElementsList] = useState<DataElement[]>([]);
  const [loading, setLoading] = useState<boolean>(false)
  // el setLoading queda reservado para cuando se permita filtrar elementos
  // en initComponent -> setBlockScreen
  // en filter -> setLoading para recargar unicamente la tabla.

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([setTimeout(() => { }, 500)]).then(function (result: any[]) {
      setBlockScreen(false)
    }).catch((error) => {
      setBlockScreen(false)
    })
  };

  useEffect(initComponent, [])

  const setFilter = () => {
    setLoading(true)
    Promise.all([filterElements(selectedProject, {})]).then(function (results) {
      setElementsList(results[0])
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    });
  }

  useEffect(setFilter, [selectedProject])

  const handleDoubleClickElement = (rowData: any) => {
    handleDoubleClickRow(selectedProject, rowData.code, navigate)
  }

  return (
    <>
      <PageContainer>

        <Box paddingBottom={PADDING_BASE}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="darkgreen" href="/tickets/listing">
              Home
            </Link>
            <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
              Elementos
            </Typography>
          </Breadcrumbs>
        </Box>

        <ElementsListingActions selectedProject={selectedProject} />


        <DataTable
          columns={TableSchema}
          rows={elementsList.map(row => rowDataPreprocesor(row, selectedProject))}
          onRowDoubleClick={handleDoubleClickElement}
          loading={loading}
          columnId={columnId}
          onClickIdValue={handleDoubleClickElement}
        />

      </PageContainer>
      <Copyright marginBottom={'1rem'} />

    </>
  )
}
